import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import adminApiClient from 'api/adminApiClient';

interface AdminState {}

const initialState: AdminState = {};

const getBOAdminsPagedList = createAsyncThunk(
  'admin/getBOAdminsPagedList',
  async ({
    pageNumber,
    pageSize,
  }: {
    pageNumber: number;
    pageSize: number;
  }) => {
    return adminApiClient.getBOAdminsPagedList(pageSize, pageNumber);
  },
);

const grantAdminRole = createAsyncThunk(
  'admin/grantAdminRole',
  async (userId: string) => {
    return adminApiClient.grantAdminRole(userId);
  },
);

const getMembersWithoutAdminRoleShort = createAsyncThunk(
  'admin/getMembersWithoutAdminRoleShort',
  async () => {
    return adminApiClient.getMembersWithoutAdminRoleShort();
  },
);

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {},
});

const { reducer } = adminSlice;

export {
  getBOAdminsPagedList,
  grantAdminRole,
  getMembersWithoutAdminRoleShort,
};
export default reducer;
